<template>
  <div class="card">
    <div class="card-header">
      <h4>Integrations <span class="h4-icon"><i class="fa fa-cogs"></i></span></h4>
    </div>
    <div class="card-body">
      <b-row>
        <b-col v-if="project.projectState !== this.PROJECT_STATE_PUBLISHED" md="12" sm="12" class="mt-2">
          <label>The following Integrations can be turned <b>On</b> after this project is published.</label>
        </b-col>
      </b-row>
      <div class="d-flex flex-wrap justify-content-between">
        <div class="mt-2 flex-grow-1 pr-2">
          <b>Airtable:</b>
          <span v-if="project.isAirtable"><i class="fa-solid fa-square-check text-success"></i> On</span>
          <span v-else><i class="fa-solid fa-square-xmark text-danger"></i> Off</span>
        </div>
        <div class="mt-2 flex-none">
          <b-btn v-show="project.projectState === this.PROJECT_STATE_PUBLISHED" size="sm" variant="primary"
            :to="{ name: 'ProjectAirtable', params: { id: $route.params.id } }"><i class="mr-2 fa fa-pencil"></i>Edit
          </b-btn>
        </div>
      </div>
      <div class="d-flex flex-wrap justify-content-between">
        <div class="mt-2 flex-grow-1 pr-2">
          <b>SciStarter:</b>
          <span v-if="project.isSciStarter"><i class="fa-solid fa-square-check text-success"></i> On</span>
          <span v-else><i class="fa-solid fa-square-xmark text-danger"></i> Off</span>
        </div>
        <div class="mt-2 flex-none">
          <b-btn v-show="project.projectState === this.PROJECT_STATE_PUBLISHED" size="sm" variant="primary"
            :to="{ name: 'ProjectSciStarter', params: { id: $route.params.id } }"><i class="mr-2 fa fa-pencil"></i>Edit
          </b-btn>
        </div>
      </div>
      <div class="d-flex flex-wrap justify-content-between">
        <div class="mt-2 flex-grow-1 pr-2">
          <b>Zooniverse:</b>
          <span v-if="project.isZooniverse"><i class="fa-solid fa-square-check text-success"></i> On</span>
          <span v-else><i class="fa-solid fa-square-xmark text-danger"></i> Off</span>
        </div>
        <div class="mt-2 flex-none">
          <b-btn v-show="project.projectState === this.PROJECT_STATE_PUBLISHED" size="sm" variant="primary"
            :to="{ name: 'ProjectZooniverse', params: { id: $route.params.id } }"><i class="mr-2 fa fa-pencil"></i>Edit
          </b-btn>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {
      project: {
        projectState: null,
        isAirtable: false,
        isSciStarter: false,
        isZooniverse: false,
      },
    }
  },
  props: {
    projectState: {
      type: Number,
      required: true,
      default: null,
    },
    isAirtable: {
      type: Boolean,
      required: true,
      default: false,
    },
    isSciStarter: {
      type: Boolean,
      required: true,
      default: false,
    },
    isZooniverse: {
      type: Boolean,
      required: true,
      default: false,
    },
  },

  created() {
    this.project.projectState = this.projectState
    this.project.isAirtable = this.isAirtable
    this.project.isSciStarter = this.isSciStarter
    this.project.isZooniverse = this.isZooniverse
    console.log('integrations created', this.project)
  },

  watch: {
    projectState(newVal) {
      console.log('project state watch')
      if (newVal) {
        this.project.projectState = newVal
      }
    },
    isAirtable(newVal) {
      if (newVal) {
        this.project.isAirtable = newVal
      }
    },
    isSciStarter(newVal) {
      if (newVal) {
        this.project.isSciStarter = newVal
      }
    },
    isZooniverse(newVal) {
      if (newVal) {
        this.project.isZooniverse = newVal
      }
    }
  },
}

</script>

<style scoped lang="scss"></style>
